<template>
  <div class="shinsotsu-saiyou">
    <div class="s-title">
      <p class="s-title_p">
        <span>中</span>
        <span>途</span>
        <span>採</span>
        <span>用</span>
      </p>
    </div>
    <div class="s-top">
      <h1 class="s-top_title">ファミリー庭園とは？</h1>
      <p class="s-top_p">
        当社は、家の外まわり（外構・お庭など）をデザイン・設計・施工する会社です。
        <br />ホームページの施工実績数やお客様の声などを見ていただければ分かるかと思われますが、弊社は日本一の規模を誇る、業界のリーディングカンパニーです。
      </p>
      <p class="s-top_ledingCompany">Leading Company</p>
      <img src="/newgrad/leading-company.png" />
    </div>

    <h1 class="s-top_title">求めている人材</h1>
    <div class="s-box2">
      <p>
        求めている人材は「真面目な方」。
        <br />そして、弊社の経営理念である「お客様の利益」に共感し、私たちと一緒に仕事に取り組んでいただける方です。
      </p>
      <p>
        ノルマや飛び込み営業はありません。
        <br />未経験者でも仕事がしやすいよう、業務の多くはシステム化されており、お客様にご満足いただけるノウハウがあります。
      </p>
      <img src="/newgrad/chutosaiyou.jpg" class="s-box2-img" />
      <p>お客様と直接打合せを行うので（BtoC）、お客様から直接嬉しいお言葉をいただけてやりがいを感じることができます。</p>
      <a href="http://famitei.co.jp/l_list.php" class="tegami-btn">お客様からの手紙</a>
    </div>

    <h1 class="s-top_title">採用フロー</h1>
    <div class="s-saiyou">
      <div class="s-saiyou-flow">
        <p class="s-saiyou-flow_p">会社説明会</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">面接(複数回)・適正テスト</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">内定</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">
          <small>(入社日相談の上)</small>入社
        </p>
      </div>

      <div class="s-saiyou_setsumeikai">
        <h1 class="s-top_title">会社説明会</h1>
        <p>
          下記のお問い合わせフォームもしくはお電話にて、事前予約をお願いします。
          <br />その際に時間などを調整いたします。
          <br />また説明会後、すぐ1次面接させて頂くことも可能ですので、
          <br />ご希望の方は履歴書をご持参ください。
        </p>
        <p class="red">WEB説明会・面接も随時開催中</p>
      </div>
    </div>

    <div class="s-entry">
      <div class="s-entry-way">
        <p class="s-entry-way_tel">
          お電話でのご予約はこちらから
          <br />
          <span class="s-entry-way_tel-number">
            <font-awesome-icon icon="phone-alt" class="phone-alt" />06-6777-9544
          </span>
          <br />
          <span>
            ネットでのご予約、お申し込みは
            <br />下記メールフォームより受け付けております
          </span>
        </p>
      </div>

      <FormStep v-bind:step="1"></FormStep>

      <div class="errorMessage" v-show="ErrorTop">
        <p>
          入力に誤りがあるか、未入力になっています。
          <br />再度ご確認のうえ、修正してください。
        </p>
      </div>
      <div id="a"></div>

      <div class="s-entry-form">
        <FormWaku v-bind:hissu="true" ref="job">
          <template v-slot:title>職種選択</template>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="job" value="プランナー（総合職）" v-model="form_data.job" />プランナー（総合職）
          </label>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="job" value="事務職（一般職）" v-model="form_data.job" />事務職（一般職）
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.job">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="kinmuchi">
          <template v-slot:title>
            希望勤務地
            <br />
            <span class="font-red">※複数選択可</span>
          </template>
          <div class="s-entry-form_item-a flex">
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="大阪府" v-model="form_data.kinmuchi" />大阪府
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="奈良県" v-model="form_data.kinmuchi" />奈良県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="兵庫県" v-model="form_data.kinmuchi" />兵庫県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="京都府" v-model="form_data.kinmuchi" />京都府
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="滋賀県" v-model="form_data.kinmuchi" />滋賀県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="和歌山県" v-model="form_data.kinmuchi" />和歌山県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="神奈川県" v-model="form_data.kinmuchi" />神奈川県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="埼玉県" v-model="form_data.kinmuchi" />埼玉県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="三重県" v-model="form_data.kinmuchi" />三重県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="愛知県(名古屋)" v-model="form_data.kinmuchi" />愛知県(名古屋)
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="福岡県" v-model="form_data.kinmuchi" />福岡県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="どこでもOK" v-model="form_data.kinmuchi" />どこでもOK
            </label>
          </div>
          <template v-slot:error>
            <p class="error" v-show="check.kinmuchi">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <div class="form-midashi">プロフィール</div>

        <FormWaku v-bind:hissu="true" ref="kanji">
          <template v-slot:title>お名前</template>
          <label class="s-entry-form_item-a-item">
            <input type="text" class="name" placeholder="例：山田 太郎" v-model="form_data.name.kanji" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.kanji">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="furigana">
          <template v-slot:title>ふりがな</template>
          <label class="s-entry-form_item-a-item">
            <input
              type="text"
              class="name"
              placeholder="例：やまだ たろう"
              v-model="form_data.name.furigana"
            />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.furigana">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="seibetsu">
          <template v-slot:title>性別</template>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="seibetsu" value="男性" v-model="form_data.seibetsu" />男性
          </label>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="seibetsu" value="女性" v-model="form_data.seibetsu" />女性
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.seibetsu">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="age">
          <template v-slot:title>年齢</template>
          <input
            type="text"
            class="age s-entry-form_item-a-item"
            placeholder="例：28"
            v-model="form_data.age"
          />&nbsp;歳
          <template v-slot:error>
            <p class="error" v-show="check.age">
              <font-awesome-icon icon="exclamation-triangle" />
              {{check.age}}
            </p>
          </template>
        </FormWaku>

        <FormWaku>
          <template v-slot:title>住所</template>
          <label class="s-entry-form_item-a-item">
            〒&nbsp;
            <input
              type="tel"
              v-model="form_data.juusyo.yuubin_num"
              class="yubin-num"
              placeholder="000-0000"
            />
            <button class="address-search" v-on:click="addressSearch">住所検索</button>
          </label>
          <br />
          <label class="s-entry-form_item-a-item">
            <input type="text" class="addless" v-model="form_data.juusyo.address" />
          </label>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="tel">
          <template v-slot:title>電話番号</template>
          <label class="s-entry-form_item-a-item">
            <input type="tel" class="name" placeholder="例：080-0000-0000" v-model="form_data.tel" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.tel">
              <font-awesome-icon icon="exclamation-triangle" />
              {{check.tel}}
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="mail">
          <template v-slot:title>メールアドレス</template>
          <label class="s-entry-form_item-a-item">
            <input
              type="text"
              class="email"
              placeholder="例：example@example.com"
              v-model="form_data.mail"
            />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.mail">
              <font-awesome-icon icon="exclamation-triangle" />
              {{check.mail}}
            </p>
          </template>
        </FormWaku>

        <div class="form-midashi">職務経歴</div>
        <FormWaku v-bind:hissu="true" ref="beforCompany">
          <template v-slot:title>直近の在籍会社名</template>
          <label class="s-entry-form_item-a-item">
            <input type="text" class="email" v-model="form_data.beforCompany" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.beforCompany">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="zaiseki">
          <template v-slot:title>在籍期間</template>
          <label class="s-entry-form_item-a-item">
            <input
              type="text"
              class="email"
              placeholder="例：OOOO年OO月～OOOO年OO月"
              v-model="form_data.zaiseki"
            />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.zaiseki">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="gyoumunaiyou">
          <template v-slot:title>前職業務内容</template>
          <label class="s-entry-form_item-a-item">
            <textarea class="textarea-q" v-model="form_data.gyoumunaiyou" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.gyoumunaiyou">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku>
          <template v-slot:title>入社可能時期</template>
          <label class="s-entry-form_item-a-item">
            <select class="nengetsu" v-model="form_data.ziki.year">
              <option value>--</option>
              <option v-bind:value="i" v-for="(i,index) in ziki_year" v-bind:key="index">{{i}}</option>
            </select>&nbsp;年
          </label>
          <label class="s-entry-form_item-a-item">
            <select class="nengetsu" v-model="form_data.ziki.month">
              <option value>--</option>
              <option v-bind:value="i" v-for="(i,index) in 12" v-bind:key="index">{{i}}</option>
            </select>&nbsp;月
          </label>
        </FormWaku>

        <FormWaku>
          <template v-slot:title>
            ご質問
            <br />ご要望など
          </template>
          <label class="s-entry-form_item-a-item">
            <textarea class="textarea-q" v-model="form_data.question" />
          </label>
          <template v-slot:error>
            <p class="error"></p>
          </template>
        </FormWaku>
      </div>
      <div v-on:click="form_check()">
        <FormBtn>
          <template>入力内容の確認画面へ</template>
        </FormBtn>
      </div>
    </div>
  </div>
</template>

<script>
import FormWaku from "@/components/form_waku.vue";
import FormStep from "@/components/form_step.vue";
import FormBtn from "@/components/form_btn.vue";
export default {
  name: "shinsots-saiyou",
  metaInfo: {
    title: "中途採用",
    meta: [
      {
        name: "description",
        content: ""
      }
    ]
  },
  components: {
    FormWaku,
    FormStep,
    FormBtn
  },
  props: { form_data: Object, click: Boolean },
  data() {
    return {
      pref: "",
      city: "",
      town: "",
      ziki_year: []
    };
  },
  methods: {
    //フォームチェック
    form_check() {
      this.$emit("click_kakunin");
      var self = this;
      var errorScroll = function(key) {
        self.$nextTick(function() {
          self.$refs[key].$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        });
      };
      //エラーがなければ確認ページ、あればその場所までスクロール
      if (!this.error) {
        this.$router.push("/kakunin");
      } else {
        this.$nextTick(function() {
          Object.keys(this.check).forEach(function(key) {
            if (this[key]) {
              errorScroll(key);
            }
          }, this.check);
        });
      }
    },
    //郵便番号住所検索クリックイベント
    addressSearch() {
      var self = this;
      fetch(
        "https://famitei.co.jp/newgrad/api/zip.php?zip=" +
          this.form_data.juusyo.yuubin_num
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(address) {
          self.pref = JSON.stringify(address["pref"]);
          self.city = JSON.stringify(address["city"]);
          self.town = JSON.stringify(address["town"]);
          self.form_data.juusyo.address =
            self.pref.replace(/"/g, "") +
            self.city.replace(/"/g, "") +
            self.town.replace(/"/g, "");
        });
    }
  },
  mounted() {
    //入社可能年
    var now_year = new Date().getFullYear();
    for (var ii = now_year; ii <= now_year + 10; ii++) {
      this.ziki_year.push(ii);
    }
  },
  computed: {
    //未入力、入力エラーがあるかないか
    error() {
      if (!this.form_data.gyoumunaiyou) {
        return true;
      } else if (!this.form_data.zaiseki) {
        return true;
      } else if (!this.form_data.beforCompany) {
        return true;
      } else if (!this.form_data.mail || !this.form_data.mail.match(/\w@\w/)) {
        return true;
      } else if (
        !this.form_data.tel ||
        !this.form_data.tel.match(/^[0-9-]+$/)
      ) {
        return true;
      } else if (!this.form_data.age || !this.form_data.age.match(/\d+/)) {
        return true;
      } else if (!this.form_data.seibetsu) {
        return true;
      } else if (!this.form_data.name.furigana) {
        return true;
      } else if (!this.form_data.name.kanji) {
        return true;
      } else if (!this.form_data.kinmuchi.length) {
        return true;
      } else if (!this.form_data.job) {
        return true;
      }
      return false;
    },
    //フォームトップのエラーメッセージ表示
    ErrorTop() {
      if (Object.values(this.check).length) {
        var a = false;
        Object.values(this.check).forEach(function(i) {
          if (i) {
            a = true;
          }
        });
        return a;
      }
      return false;
    },
    //フォーム監視エラーメッセージ表示
    check() {
      var kekka = {};
      if (!this.click) {
        return kekka;
      }
      var kekka_check = function(i, ii) {
        if (i && ((Array.isArray(i) && i.length) || !Array.isArray(i))) {
          if (ii) {
            return ii(i);
          }
          return false;
        }
        return "入力してください";
      };
      kekka.gyoumunaiyou = kekka_check(this.form_data.gyoumunaiyou);
      kekka.zaiseki = kekka_check(this.form_data.zaiseki);
      kekka.beforCompany = kekka_check(this.form_data.beforCompany);
      kekka.mail = kekka_check(this.form_data.mail, function(mail) {
        if (!mail.match(/\w@\w/)) {
          return "入力に誤りがあります";
        }
      });
      kekka.tel = kekka_check(this.form_data.tel, function(tel) {
        if (!tel.match(/^[0-9-]+$/)) {
          return "入力に誤りがあります";
        }
      });
      kekka.age = kekka_check(this.form_data.age, function(age) {
        if (!age.match(/\d+/)) {
          return "入力に誤りがあります";
        }
      });
      kekka.seibetsu = kekka_check(this.form_data.seibetsu);
      kekka.furigana = kekka_check(this.form_data.name.furigana);
      kekka.kanji = kekka_check(this.form_data.name.kanji);
      kekka.kinmuchi = kekka_check(this.form_data.kinmuchi);
      kekka.job = kekka_check(this.form_data.job);
      return kekka;
    }
  }
};
</script>

<style lang="scss">
.shinsotsu-saiyou {
  letter-spacing: 0.1em;
  line-height: 1.8em;
  text-align: center;
  .s-title {
    background-image: linear-gradient(
      -45deg,
      #ffffff 25%,
      #dadada 25%,
      #dadada 50%,
      #ffffff 50%,
      #ffffff 75%,
      #dadada 75%,
      #dadada
    );
    background-size: 7px 7px;
    padding: 10%;
    &_p {
      border-bottom: 2px solid;
      margin: auto;
      width: 50%;
      span + span {
        margin-left: 0.5em;
      }
    }
  }
  .s-top {
    &_title {
      font-weight: 100;
      letter-spacing: 0.2em;
      margin: 10% 0 5%;
    }
    &_p {
      margin: 0 5%;
    }
    &_ledingCompany {
      font-family: "Charm";
      font-size: 220%;
      font-style: oblique;
      margin: 5% 0 1%;
    }
    img {
      width: 100%;
    }
  }
  .s-box2 {
    p {
      margin: 0 5% 3%;
    }
  }
  .s-saiyou {
    &-flow {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 10%;
      &_p {
        border: 1px solid;
        padding: 1% 2%;
        margin: 0 1%;
        background-color: rgb(243, 243, 243);
      }
    }
  }

  .s-entry {
    & .form-midashi {
      font-size: 120%;
      padding: 1% 2%;
      background-color: #9c9c9c;
      color: white;
      border: 1px solid #7a7a7a;
    }
    &-way {
      background-color: #f6f6f6;
      &_tel {
        padding: 1% 0;
        border: solid 1px #b8b8b8;
        &-number {
          color: #3f6eb2;
          .phone-alt {
            margin: 0 2%;
          }
        }
      }
    }

    .errorMessage {
      color: red;
      background-color: #fff3f3;
      border: #f66e6e 1px solid;
      margin: 5% 0;
    }
  }
  //pc style
  @media screen and (min-width: 769px) {
    .s-title {
      &_p {
        font-size: 280%;
      }
    }
    .s-top {
      img {
        margin-top: 15px;
      }
      &_p {
        width: 700px;
        margin: 0 auto 50px;
      }
    }
    .s-entry {
      &-form {
        border: none;
        &_item {
          border: 1px solid #c8c8c8;
          border-top: none;
          &-q {
            & p {
              letter-spacing: 0.05em;
            }
          }
          &:nth-child(1) {
            border-top: 1px solid #c8c8c8;
          }
          & .age {
            width: 3em;
            font-size: 15px;
          }
        }
      }
      & .form-midashi {
        margin-top: 30px;
      }
      &-way {
        max-width: 60%;
        margin: 0 auto 5%;
        letter-spacing: 0.3em;
        &_tel {
          &-number {
            font-size: 220%;
          }
        }
      }
    }
    .s-box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      max-width: 1000px;
      margin: 0 auto;
      img {
        width: 60%;
      }
      &-setsumei {
        width: 40%;

        &_title {
          letter-spacing: 0.15em;
          font-family: "Sawarabi Mincho";
        }
        &_p {
          text-indent: 1em;
          padding-left: 1em;
          text-align: left;
        }
      }
    }
    .s-box2 {
      &-img {
        max-width: 600px;
      }
      & p {
        width: 500px;
        margin: 0 auto 20px;
      }
    }
    .smaho {
      display: none;
    }
  }
  //smartphone style
  @media screen and (max-width: 768px) {
    overflow: hidden;
    .s-title {
      &_p {
        font-size: 180%;
        width: 100%;
        padding-bottom: 2%;
      }
    }
    .s-top {
      margin: 15% 0 20%;
      &_title {
        margin: 0 0 10%;
      }
      &_p {
        margin-bottom: 10%;
      }
      img {
        margin-top: 5%;
      }
    }
    .s-box {
      &-img {
        display: none;
      }
      &-setsumei {
        margin: 0 5%;
        &_title {
          margin: 15% 0 10%;
          font-family: "Sawarabi Mincho";
        }
        &_p {
          margin-bottom: 20%;
        }
      }
    }
    .s-box2 {
      margin-bottom: 20%;
      &-img {
        width: 100%;
      }
    }
    .s-saiyou {
      margin-bottom: 20%;
      &-flow {
        margin: 12% 15%;
        &_p {
          width: 100%;
          font-size: 110%;
          padding: 2%;
        }
      }
      .pc {
        display: none;
      }
      &_setsumeikai {
        margin: 0 5%;
      }
    }
    .s-entry {
      &-way {
        width: 100%;
        padding: 2.5% 0;
        margin-bottom: 10%;
        &_tel {
          padding: 5% 2%;
          width: 90%;
          margin: 0 2.5%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          &-number {
            font-size: 180%;
            width: 100%;
            padding: 2% 0 5%;
            font-weight: bold;
          }
        }
      }
      & .age {
        width: 20%;
      }
    }
  }
  & .tegami-btn {
    text-decoration: none;
    border: 1px solid rgb(160, 160, 160);
    background-color: rgba(238, 238, 238, 0.644);
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    color: black;
    padding: 10px 20px;
    margin: 5% auto 10%;
    width: 50%;
    display: block;
  }
  .red {
    color: red;
    font-weight: bold;
  }
}
</style>